<template>
  <card class="form-card">
    <template slot="header">
      <div class="form-title">{{ title }}</div>
    </template>
    <template>
      <div class="row justify-content-center">
        <div class="col">
          <fg-input type="password"
                    label="New password"
                    v-model="new_password">
          </fg-input>
        </div>
      </div>
      <div class="row justify-content-center last-input">
        <div class="col">
          <fg-input type="password"
                    label="New password confirmation"
                    v-model="confirm_new_password">
          </fg-input>
        </div>
      </div>
      <div class="row justify-content-center">
        <button type="button" class="btn-plyo-default" @click="saveNewPassword">
          {{ save_new_password }}
        </button>
      </div>
    </template>
  </card>
</template>

<script>
  import Card from '@/components/UIComponents/Cards/Card.vue'
  import axios from 'axios'
  
  export default {
    components: {
      Card,
    },
    data: function () {
      return {
        title: "Change Your Password",
        new_password: "",
        confirm_new_password: "",
        save_new_password: "SAVE NEW PASSWORD",
        saving_new_password: false,
      }
    },
    methods: {
      async saveNewPassword() {
        if  (!this.saving_new_password) {
          this.saving_new_password = true
            const payload = {
              uid: this.$route.params.uidb64,
              token: this.$route.params.token,
              new_password1: this.new_password,
              new_password2: this.confirm_new_password,
            }

            await axios.post(this.$store.state.endpoints.passwordResetConfirm, payload)
                .then((response)=>{
                  this.$router.push('/reset/done')
                })
                .catch((error)=>{
                  // eslint-disable-next-line
                  console.log(error);
                  this.requesting_reset = false;
                })
        }
      }
    }
  }
</script>